import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import * as Ladda from 'ladda';

@Directive({
  selector: '[ladda]'
})
export class LaddaDirective implements OnChanges {
  @Input('ladda') isLoading: boolean = false;

  private laddaButton: Ladda.LaddaButton | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(): void {
    if (!this.laddaButton) {
      // Initialize Ladda for the button element
      this.laddaButton = Ladda.create(this.el.nativeElement);
    }

    if (this.isLoading) {
      this.laddaButton.start();
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
    } else {
      this.laddaButton.stop();
      this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
    }
  }
}
